export default __webpack_public_path__ + "static/media/refactor.c5601c2f.svg";